import { Option } from "../../Filters/helpers/listItemUtils";
import { SortUtility } from "../sort";

export const resComparer = (first: Option, second: Option) => {
    const result = SortUtility.sortWithLocalCompare(first.label, second.label);

    if (result) {
        return result;
    } else if (first.id < second.id) {
        return -1;
    } else if (first.id > second.id) {
        return 1;
    }
};

export const sortByArray = (array: any[], order: number[], key: any) => {
    if (!!order.length) {
        array.sort((a, b) => {
            const A = a[key],
                B = b[key];

            let indA = order.indexOf(A);
            let indB = order.indexOf(B);

            if (indA === -1) {
                indA = order.length + 1;
            }
            if (indB === -1) {
                indB = order.length + 1;
            }

            if (indA < indB) {
                return -1;
            } else if (indA > indB) {
                return 1;
            }
            return 0;
        });
    }

    return array;
};
